import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';

// Using online images for cities to ensure they render nicely. 
// Can revert to local imports if strictly needed, but these look better for "finishing".
const cities = [
    { name: "Delhi NCR", img: "https://images.unsplash.com/photo-1587474260584-1f86212f2763?auto=format&fit=crop&w=600&q=80", link: "Delhi" },
    { name: "Bangalore", img: "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?auto=format&fit=crop&w=600&q=80", link: "Bangalore" },
    { name: "Hyderabad", img: "https://images.unsplash.com/photo-1624424638545-540c6f0699fc?auto=format&fit=crop&w=600&q=80", link: "Hyderabad" },
    { name: "Pune", img: "https://images.unsplash.com/photo-1698305417835-24c52f862828?auto=format&fit=crop&w=600&q=80", link: "Pune" },
    { name: "Mumbai", img: "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?auto=format&fit=crop&w=600&q=80", link: "Mumbai" },
    { name: "Chennai", img: "https://images.unsplash.com/photo-1621516999263-6e27bda1325d?auto=format&fit=crop&w=600&q=80", link: "Chennai" },
    { name: "Kolkata", img: "https://images.unsplash.com/photo-1558431382-27e303142255?auto=format&fit=crop&w=400&q=80", link: "Kolkata" },
];

const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 3 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 2 }
};

const TopPlacesSection = () => {
    return (
        <section className="py-20 bg-white relative z-10">
            <div className="container mx-auto px-4">
                <div className="flex justify-between items-end mb-8">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800">Top Study <span className="text-brand-orange">Places</span></h2>
                        <div className="w-16 h-1 bg-brand-orange mt-2 rounded-full"></div>
                    </div>
                </div>

                {/* Carousel with low z-index buttons */}
                <div className="relative">
                    <style>{`
                        .places-carousel .react-multiple-carousel__arrow {
                            z-index: 10 !important;
                        }
                        .places-carousel .react-multiple-carousel__arrow:hover {
                            background: rgba(0, 0, 0, 0.8) !important;
                        }
                    `}</style>
                    <Carousel
                        responsive={responsive}
                        infinite
                        autoPlay
                        autoPlaySpeed={3000}
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                        containerClass="places-carousel"
                        itemClass="px-2"
                    >
                        {cities.map((city, index) => (
                            <Link to={`/TopStudy-colleges/${city.link}`} key={index} className="group block h-full">
                                <div className="relative rounded-2xl overflow-hidden aspect-[3/4] shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:-translate-y-1 border border-gray-100">
                                    <img src={city.img} alt={city.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end p-4">
                                        <h3 className="text-white font-bold text-lg">{city.name}</h3>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default TopPlacesSection;
